module.exports = __webpack_public_path__ + "assets/img/huizhang.90830f20.jpeg";